'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _WithError = require('./WithError');

var _WithError2 = _interopRequireDefault(_WithError);

var _dom = require('./utility/dom');

var _reduxForm = require('./utility/redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

// http://tympanus.net/codrops/2013/10/15/animated-checkboxes-and-radio-buttons-with-svg/

var Checkbox = (_temp2 = _class = function (_PureComponent) {
	_inherits(Checkbox, _PureComponent);

	function Checkbox() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Checkbox);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onKeyDown = function (event) {
			var onKeyDown = _this.props.onKeyDown;


			if (onKeyDown) {
				onKeyDown(event);
			}

			if (event.defaultPrevented) {
				return;
			}

			if ((0, _dom.submitFormOnCtrlEnter)(event, _this.checkbox)) {
				return;
			}
		}, _this.onFocus = function (event) {
			var onFocus = _this.props.onFocus;

			if (onFocus) {
				onFocus(event);
			}
			_this.setState({ isFocused: true });
		}, _this.onBlur = function (event) {
			var _this$props = _this.props,
			    onBlur = _this$props.onBlur,
			    value = _this$props.value;

			if (onBlur) {
				(0, _reduxForm.onBlurForReduxForm)(onBlur, event, value);
			}
			_this.setState({ isFocused: false });
		}, _this.storeInstance = function (ref) {
			return _this.checkbox = ref;
		}, _this.focus = function () {
			return _this.checkbox.focus();
		}, _this.toggle = function (event) {
			// If a link was clicked - don't treat it as a checkbox label click.
			// (is used for things like "✓ Read and accepted the <a>licence agreement</a>")
			if (event.target.tagName.toLowerCase() === 'a') {
				return;
			}

			_this.focus();

			var _this$props2 = _this.props,
			    disabled = _this$props2.disabled,
			    onChange = _this$props2.onChange,
			    value = _this$props2.value;


			if (disabled) {
				return;
			}

			onChange(!value);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Checkbox, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    value = _props.value,
			    error = _props.error,
			    indicateInvalid = _props.indicateInvalid,
			    multiline = _props.multiline,
			    disabled = _props.disabled,
			    ariaLabel = _props.ariaLabel,
			    children = _props.children,
			    style = _props.style,
			    className = _props.className,
			    onClick = _props.onClick;
			var isFocused = this.state.isFocused;


			return _react2.default.createElement(
				_WithError2.default,
				{
					error: error,
					indicateInvalid: indicateInvalid,
					style: style,
					className: (0, _classnames2.default)(className, 'rrui__checkbox', {
						// 'rrui__checkbox--checked'  : value,
						'rrui__checkbox--invalid': indicateInvalid && error,
						'rrui__checkbox--disabled': disabled,
						'rrui__checkbox--multiline': multiline,
						'rrui__checkbox--focus': isFocused
					}) },
				_react2.default.createElement(
					'label',
					{
						className: (0, _classnames2.default)('rrui__input', {
							'rrui__input--multiline': multiline
						}) },
					_react2.default.createElement(
						'span',
						{ className: 'rrui__checkbox__checkbox' },
						_react2.default.createElement('input', {
							id: id,
							ref: this.storeInstance,
							type: 'checkbox',
							'aria-label': this.props['aria-label'] || ariaLabel,
							'aria-invalid': indicateInvalid && error ? true : undefined,
							checked: value,
							disabled: disabled,
							onClick: onClick,
							onChange: this.toggle,
							onKeyDown: this.onKeyDown,
							onFocus: this.onFocus,
							onBlur: this.onBlur,
							className: 'rrui__checkbox__input' }),
						_react2.default.createElement(
							'svg',
							{
								className: (0, _classnames2.default)('rrui__checkbox__box', {
									'rrui__checkbox__box--checked': value
								}),
								focusable: 'false',
								viewBox: '0 0 24 24',
								'aria-hidden': 'true' },
							_react2.default.createElement('path', { d: value ? CHECKBOX_CHECKED_PATH : CHECKBOX_UNCHECKED_PATH }),
							' }'
						),
						_react2.default.createElement('span', { className: 'rrui__checkbox__box-background' }),
						_react2.default.createElement('span', { className: 'rrui__checkbox__focus-ring' })
					),
					children && _react2.default.createElement(
						'span',
						{
							className: (0, _classnames2.default)('rrui__checkbox__label', {
								'rrui__checkbox__label--multiline': multiline
							}) },
						children
					)
				)
			);
		}

		// render_static()
		// {
		// 	const { name, value, focus, disabled, children } = this.props
		//
		// 	return (
		// 		<div className="rrui__rich__fallback">
		// 			{/* This checkbox will be sent as either "on" or `undefined` */}
		// 			<input
		// 				type="checkbox"
		// 				name={ name }
		// 				disabled={ disabled }
		// 				defaultChecked={ value }
		// 				autoFocus={ focus }/>
		//
		// 			<label className="rrui__checkbox__label rrui__checkbox__label--fallback">
		// 				{ children }
		// 			</label>
		// 		</div>
		// 	)
		// }

	}]);

	return Checkbox;
}(PureComponent), _class.propTypes = {
	// HTML `id` attribute.
	id: _propTypes2.default.string,

	// HTML form field "name"
	name: _propTypes2.default.string,

	// `true`/`false`
	value: _propTypes2.default.bool.isRequired,

	// Set to `true` to enable multiline label
	multiline: _propTypes2.default.bool.isRequired,

	// Disables the checkbox
	disabled: _propTypes2.default.bool.isRequired,

	// Indicates that the input is invalid.
	error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),

	// `onClick` handler
	onClick: _propTypes2.default.func,

	// `onChange` handler
	onChange: _propTypes2.default.func,

	// When `true` autofocuses the checkbox
	focus: _propTypes2.default.bool.isRequired,

	// `aria-label` attribute.
	// Deprecated, use `aria-label` instead.
	ariaLabel: _propTypes2.default.string,

	// The label (text)
	children: _propTypes2.default.node,

	// CSS class
	className: _propTypes2.default.string,

	// CSS style object
	style: _propTypes2.default.object
}, _class.defaultProps = {
	disabled: false,
	value: false,
	multiline: false,
	focus: false,

	// Show `error` (if passed).
	indicateInvalid: true
}, _temp2);
exports.default = Checkbox;


var CHECKBOX_CHECKED_PATH = "M21.3,0H2.7C1.2,0,0,1.2,0,2.7v18.7C0,22.8,1.2,24,2.7,24h18.7c1.5,0,2.7-1.2,2.7-2.7V2.7C24,1.2,22.8,0,21.3,0z M9.3,18.7 L2.7,12l1.9-1.9l4.8,4.8L19.5,4.8l1.9,1.9L9.3,18.7z";
var CHECKBOX_UNCHECKED_PATH = "M21.2,0H2.9C1.3,0,0,1.3,0,2.9v18.3C0,22.8,1.3,24,2.9,24h18.3c1.6,0,2.8-1.3,2.8-2.8V2.9C24,1.3,22.8,0,21.2,0z M22.3,20.7c0,0.9-0.8,1.7-1.7,1.7H3.4c-0.9,0-1.7-0.8-1.7-1.7V3.4c0-0.9,0.8-1.7,1.7-1.7h17.2c0.9,0,1.7,0.8,1.7,1.7V20.7z";

// Thin.
// const CHECKBOX_UNCHECKED_PATH = "M21.2,0H2.9C1.3,0,0,1.3,0,2.8v18.3C0,22.7,1.3,24,2.9,24h18.3c1.6,0,2.8-1.3,2.8-2.8V2.8C24,1.3,22.8,0,21.2,0z M23.2,20.3c0,1.6-1.3,2.8-2.8,2.8H3.7c-1.6,0-2.8-1.3-2.8-2.8V3.7c0-1.6,1.3-2.8,2.8-2.8h16.6c1.6,0,2.8,1.3,2.8,2.8V20.3z"
//# sourceMappingURL=Checkbox.js.map